module.exports = __webpack_public_path__ + "img/label_czdd.72f082f6.png";